import { preferredLocaleSelector } from 'redux/selectors';

export const getReduxLanguageDetector = store => ({
  name: 'reduxLanguageDetector',

  lookup(options) {
    const state =  store.getState();
    const preferredLocale = preferredLocaleSelector(state);
    
    // Return the user's preferred locale if available
    return preferredLocale;
  },


  cacheUserLanguage(lng) {
    // We don't need to cache anything since we get the language from Redux
    // The backend handles saving the user's preference
  }
})

export default getReduxLanguageDetector;